import { Country } from "@/types/Country";
import { Language } from "@/types/Language";

export const countryCodeMap: Record<Country, Partial<Record<Language | "native", string>>> = {
  // The "native" here refers to the native name of the country in its primary language.
  at: { native: "Österreich", en: "Austria" },
  ae: { native: "الإمارات العربية المتحدة", en: "United Arab Emirates" },
  au: { native: "Australia" },
  be: { de: "Belgien", fr: "Belgique", native: "België", en: "Belgium" },
  bg: { native: "Bulgaria" },
  ca: { native: "Canada" },
  ch: { native: "Switzerland" },
  cy: { native: "Κύπρος", en: "Cyprus" },
  cz: { native: "Česká republika", en: "Czech Republic" },
  de: { native: "Deutschland", en: "Germany" },
  dk: { native: "Danmark", en: "Denmark" },
  ee: { native: "Eesti", en: "Estonia" },
  es: { native: "España", en: "Spain" },
  fi: { native: "Suomi", fi: "Suomi", sv: "Finland", en: "Finland" },
  fr: { native: "France" },
  gb: { native: "United Kingdom" },
  gr: { native: "Ελλάδα", en: "Greece" },
  hr: { native: "Hrvatska", en: "Croatia" },
  hu: { native: "Magyarország", en: "Hungary" },
  ie: { native: "Ireland" },
  il: { native: "ישראל", en: "Israel" },
  it: { native: "Italia", it: "Italia", en: "Italy", de: "Italien" },
  jp: { native: "Japan" },
  kr: { native: "대한민국", en: "South Korea" },
  lt: { native: "Lietuva", en: "Lithuania" },
  li: { native: "Liechtenstein" },
  lu: { de: "Luxemburg", native: "Luxembourg" },
  lv: { native: "Latvija", en: "Latvia" },
  mt: { native: "Malta" },
  nl: { native: "Nederland", en: "Netherlands" },
  pl: { native: "Polska", en: "Poland" },
  pt: { native: "Portugal" },
  qa: { native: "قطر", en: "Qatar" },
  ro: { native: "România" },
  sa: { native: "المملكة العربية السعودية", en: "Saudi Arabia" },
  se: { native: "Sverige", en: "Sweden" },
  sg: { native: "Singapore" },
  si: { native: "Slovenija", en: "Slovenia" },
  sk: { native: "Slovensko", en: "Slovakia" },
  us: { native: "United States" },
  no: { native: "Norge", en: "Norway" },
  is: { native: "Ísland", en: "Iceland" },
  tw: { native: "台灣", en: "Taiwan" },
  hk: { native: "香港", en: "Hong Kong" },
  ag: { native: "Antigua & Barbuda" },
  aw: { native: "Aruba" },
  bb: { native: "Barbados" },
  bm: { native: "Bermudas" },
  bs: { native: "Bahamas" },
  bz: { native: "Belize" },
  cw: { native: "Curacao" },
  gy: { native: "Guyana" },
  ht: { native: "Haiti" },
  jm: { native: "Jamaica" },
  kn: { native: "Saint Kitts and Nevis" },
  ms: { native: "Montserrat" },
  sr: { native: "Suriname" },
  sx: { native: "Sint Maarten" },
  tt: { native: "Trinidad & Tobago" },
  bo: { native: "Bolivia" },
  cr: { native: "Costa Rica" },
  do: { native: "República Dominicana", en: "Dominican Republic" },
  ec: { native: "Ecuador" },
  sv: { native: "El Salvador" },
  gt: { native: "Guatemala" },
  hn: { native: "Honduras" },
  ni: { native: "Nicaragua" },
  pa: { native: "Panamá", en: "Panama" },
  py: { native: "Paraguay" },
  uy: { native: "Uruguay" },
  br: { native: "Brasil", en: "Brazil" },
  ar: { native: "Argentina" },
  cl: { native: "Chile" },
  pe: { native: "Perú", en: "Peru" },
  co: { native: "Colombia" },
  mx: { native: "México", en: "Mexico" },
  vc: { native: "St. Vincent" }
};

export const eeaCountries: Country[] = [
  "at",
  "be",
  "bg",
  "cy",
  "cz",
  "de",
  "dk",
  "ee",
  "es",
  "fi",
  "fr",
  "gb",
  "gr",
  "hr",
  "hu",
  "ie",
  "is",
  "it",
  "lt",
  "lu",
  "lv",
  "mt",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "sa",
  "se",
  "si",
  "sk"
];
